/**
 * Whether a path is the given route or one below it.
 *
 * The segment boundary is what separates them: a bare `startsWith` puts every
 * route whose name merely begins with another's under it, which lights up the
 * wrong nav entry and hands the wrong role list to the guard.
 */
export function isPathUnder(pathname: string, route: string): boolean {
  return pathname === route || pathname.startsWith(`${route}/`)
}

/**
 * The longest of the listed routes the path is under.
 *
 * Both the permission table and a tab strip ask it: the answer for
 * `/internal/system/operations/logs` is that route and not `/internal/system`,
 * which also matches and would hand back the wrong roles and light the wrong
 * tab.
 */
export function longestMatch(
  pathname: string,
  routes: readonly string[],
): string | undefined {
  let best: string | undefined
  for (const route of routes) {
    if (
      isPathUnder(pathname, route) &&
      !(best && best.length >= route.length)
    ) {
      best = route
    }
  }
  return best
}
